import { render, staticRenderFns } from "./module.vue?vue&type=template&id=04943dc8&scoped=true&"
import script from "./module.vue?vue&type=script&lang=js&"
export * from "./module.vue?vue&type=script&lang=js&"
import style0 from "./module.vue?vue&type=style&index=0&id=04943dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04943dc8",
  null
  
)

export default component.exports